import { Camera } from "lucide-react";

// One switch for every Help Center page. false = hide screenshot placeholder banners.
const SHOW_SCREENSHOT_BANNERS = false;

export default function Screenshot({ caption }) {
  if (!SHOW_SCREENSHOT_BANNERS) return null;

  return (
    <div className="my-4 flex items-center gap-3 border border-dashed border-[#D4D4D4] rounded-[10px] px-4 py-3 bg-[#FAFAFA]">
      <Camera className="w-4 h-4 text-[#A3A3A3] flex-shrink-0" />
      <p className="text-[12px] geist-regular text-[#6B7280] italic">
        {caption}
      </p>
    </div>
  );
}
